/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { VisitDetailDto } from '../models/visit-detail-dto';
import { VisitDto } from '../models/visit-dto';
import { VisitGetAllReq } from '../models/visit-get-all-req';
import { VisitListDto } from '../models/visit-list-dto';

@Injectable({
  providedIn: 'root',
})
export class VisitService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation visitList
   */
  static readonly VisitListPath = '/visit/list';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `visitList()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  visitList$Response(params: {

    /**
     * pagination load page
     */
    page?: number;
    body: VisitGetAllReq
  }): Observable<StrictHttpResponse<VisitListDto>> {

    const rb = new RequestBuilder(this.rootUrl, VisitService.VisitListPath, 'post');
    if (params) {
      rb.query('page', params.page, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<VisitListDto>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `visitList$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  visitList(params: {

    /**
     * pagination load page
     */
    page?: number;
    body: VisitGetAllReq
  }): Observable<VisitListDto> {

    return this.visitList$Response(params).pipe(
      map((r: StrictHttpResponse<VisitListDto>) => r.body as VisitListDto)
    );
  }

  /**
   * Path part for operation visitGet
   */
  static readonly VisitGetPath = '/visit/{uuid}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `visitGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  visitGet$Response(params: {

    /**
     * uuid to fetch
     */
    uuid: string;
  }): Observable<StrictHttpResponse<VisitDetailDto>> {

    const rb = new RequestBuilder(this.rootUrl, VisitService.VisitGetPath, 'get');
    if (params) {
      rb.path('uuid', params.uuid, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<VisitDetailDto>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `visitGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  visitGet(params: {

    /**
     * uuid to fetch
     */
    uuid: string;
  }): Observable<VisitDetailDto> {

    return this.visitGet$Response(params).pipe(
      map((r: StrictHttpResponse<VisitDetailDto>) => r.body as VisitDetailDto)
    );
  }

  /**
   * Path part for operation delete
   */
  static readonly DeletePath = '/visit/{uuid}';

  /**
   * Delete the desired visit
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `delete()` instead.
   *
   * This method doesn't expect any request body.
   */
  delete$Response(params: {

    /**
     * visit uuid
     */
    uuid: string;
  }): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, VisitService.DeletePath, 'delete');
    if (params) {
      rb.path('uuid', params.uuid, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Delete the desired visit
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `delete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  delete(params: {

    /**
     * visit uuid
     */
    uuid: string;
  }): Observable<void> {

    return this.delete$Response(params).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation visitPut
   */
  static readonly VisitPutPath = '/visit';

  /**
   * Put
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `visitPut()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  visitPut$Response(params: {
    body: VisitDto
  }): Observable<StrictHttpResponse<{
'message'?: string;
}>> {

    const rb = new RequestBuilder(this.rootUrl, VisitService.VisitPutPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<{
        'message'?: string;
        }>;
      })
    );
  }

  /**
   * Put
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `visitPut$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  visitPut(params: {
    body: VisitDto
  }): Observable<{
'message'?: string;
}> {

    return this.visitPut$Response(params).pipe(
      map((r: StrictHttpResponse<{
'message'?: string;
}>) => r.body as {
'message'?: string;
})
    );
  }

}
